export default "__VITE_ASSET__BQnlMq$w__"